"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f = exports.field = exports.Field = void 0;
class Field {
    constructor(name) {
        this[Symbol.toStringTag] = 'Field';
        this.name = name;
    }
}
exports.Field = Field;
function field(name) {
    return new Field(name);
}
exports.field = field;
/**
 * A shorthand {@link Field} constructor for more conveniently writing inline fields.
 *
 * @example
 * ```typescript
 * where(f`name`, '==', 'bob');
 * ```
 */
function f(strings, ...expressions) {
    const field = strings.reduce((acc, elem, i) => { var _a; return acc + elem + (((_a = expressions[i]) === null || _a === void 0 ? void 0 : _a.toString()) || ''); }, '');
    return new Field(field);
}
exports.f = f;
//# sourceMappingURL=field.js.map